export class UpdateQuestionRequest {
    caseId: number;
    questionCode: String;
    Value: String;

    constructor(_caseId: number, _questionCode: String, _value: String) {
        this.caseId = _caseId;
        this.questionCode = _questionCode;
        this.Value = _value;
    }
}
